"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoGallery = function PhotoGallery(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    "clip-path": "url(#clip0_3686_2116)"
  }, _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.4",
    d: "M19.2708 15.1042L16.6666 12.5L14.5972 14.5834H14.5833L10.4166 10.4167L5.72913 15.1042V17.1875H19.2708",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M16.6667 11.4583C17.242 11.4583 17.7083 10.992 17.7083 10.4167C17.7083 9.84137 17.242 9.375 16.6667 9.375C16.0914 9.375 15.625 9.84137 15.625 10.4167C15.625 10.992 16.0914 11.4583 16.6667 11.4583Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M19.7917 18.2292H5.20833C4.92069 18.2292 4.6875 17.996 4.6875 17.7083V7.29168C4.6875 7.00403 4.92069 6.77084 5.20833 6.77084H19.7917C20.0793 6.77084 20.3125 7.00403 20.3125 7.29168V17.7083C20.3125 17.996 20.0793 18.2292 19.7917 18.2292ZM5.72917 17.1875H19.2708V7.81251H5.72917V17.1875Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M3.125 6.77084H0V7.81251H2.60417V17.1875H0V18.2292H3.125C3.41264 18.2292 3.64583 17.996 3.64583 17.7083V7.29168C3.64583 7.00403 3.41264 6.77084 3.125 6.77084Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.4",
    d: "M0 12.5V17.1875H2.60417V15.1042L0 12.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M25 17.1875H22.3958V7.81251H25V6.77084H21.875C21.5873 6.77084 21.3541 7.00403 21.3541 7.29168V17.7083C21.3541 17.996 21.5873 18.2292 21.875 18.2292H25V17.1875Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.4",
    d: "M25 12.5L22.3959 15.1042V17.1875H25V12.5Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0_3686_2116"
  }, _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: props.foregroundColor
  }))));
};

PhotoGallery.defaultProps = {
  altText: "Photo Gallery",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
PhotoGallery.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = PhotoGallery;
exports.default = _default;